<!-- @format -->

<!-- registered users -->
<div
	class="scoreCardPoints hmf-mx-s hmf-mx-m-0 row no-gutters"
	*ngIf="displayText && registeredUser">
	<div class="col-12 hmf-mb-m">
		<div
			class="scoreCardPointsMessageContainer hmf-justify-content-center hmf-display-flex hmf-py-xs newScoreCardPointsMessage">
			<p
				*ngIf="loyalty.rewardAmount > 0"
				class="hmf-mx-xs">
				<span class="scoreCardPointsMessage"
					>{{ greeting }} You have
					<span class="pointsValue hmf-mx-xxxs hmf-mx-m-0"
						>${{ loyalty.rewardAmount }}</span
					>
					in Rewards!
				</span>
				<span
					class="scoreCardPointsMessage"
					*ngIf="!shortenPurchasePathUpdatesATCEnabled"
					>(Rewards can be applied on cart)</span
				>
				<span
					class="scoreCardPointsMessage"
					*ngIf="shortenPurchasePathUpdatesATCEnabled"
					>(Rewards can be applied in Cart or Checkout)</span
				>
			</p>
			<p
				*ngIf="loyalty.rewardAmount === 0"
				class="hmf-mx-xs">
				{{ greeting }} You're {{ loyalty.pointsToNextReward }} points away from your next
				Reward!<span class="scoreCardPointsMessage">
					Earn
					<span [ngClass]="{ 'pointsValue hmf-mx-xxxs hmf-mx-m-0': pointsShown }">{{
						pointsValue
					}}</span>
					points with the purchase.
					<shared-components-tool-tip
						class="hmf-ml-xxxs hmf-ml-m-0"
						id="scoreCardToolTipRegistered"
						[hmfIcon]="'alert-info-filled'"
						textBody="300 points = $10 Reward </br>Point value estimated based on current product price. Estimated point value does not include discounts, promotions or bonus points. See <a href='/s/scorecard-benefits' target='_blank' data-em='PDP_ScoreCard_Points_Tooltip'>ScoreCard Terms & Conditions</a> for more info.">
					</shared-components-tool-tip>
				</span>
			</p>
		</div>
	</div>
</div>
